<template>
  <div class="page-content transaction-log">
    <h1 class="page-title">{{ pageTitle }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="24">
            <DatePickerGroup
              v-model="filter"
              :showWeekly="true"
              :startPickerOptions="datePickerOptions"
              :endPickerOptions="datePickerOptions"
            ></DatePickerGroup>
            <el-button class="egl-btn-yellow" @click="getData">{{ $locale("global.search") }}</el-button>
          </el-col>
          <el-col :span="12" class="name-input">
            <el-input :placeholder="$locale('trans.log.input.placeholder')" v-model="filter.search" @keyup.enter.native="getData">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="getData"></i>
            </el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="ta-r">
        <el-button class="egl-btn-yellow" @click="exportCsv">{{ $locale("global.exportToCSV") }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <div id="print">
      <el-table
      :data="tableData"
      class="egl-table"
      stripe
      ref="table"
      @sort-change="sortChange"
      @filter-change="filterChange"
    >
      <el-table-column
        v-for="th in tableHeader"
        :key="th.prop"
        :prop="th.prop"
        :label="th.label"
        :min-width="th.width"
        :column-key="th.columnKey"
        :filters="th.filters"
        :sortable="th.sortable || false"
        :formatter="th.formatter || null"
        :align="th.align || 'center'"
      ></el-table-column>
      </el-table>
    </div>
    <CommPagination
      :total="pageCount"
      :curPage="filter.page"
      :pageSize="filter.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup.vue";
import { getTransactionLogList } from "@/helpers/service/api/report";
import CommPagination from "@/components/common/CommPagination";
import { exportCSV_fn } from "@/assets/js/transactionLogTicket_exportCSV";
import { taxRatesMap, toThousands, weekLocaleArray, formatStringFixed } from "@/utils/common";
// import tranfResData from "@/utils/tranfResData";

export default {
  name: "transactionLog",
  components: {
    DatePickerGroup,
    CommPagination,
  },
  data() {
    return {
      printObj: {
        popTitle: "取引ログ",
        id: "print"
      },
      pageTitle: "",
      filter: this.initFilter(),
      tableData: [],
      pageCount: 0,
      operationTypeOption: [
        {
          value: "create",
          label: this.$locale("global.create"),
          text: this.$locale("global.create"),
        },
        {
          value: "edit",
          label: this.$locale("global.edit"),
          text: this.$locale("global.edit"),
        },
        {
          value: "delete",
          label: this.$locale("global.delete"),
          text: this.$locale("global.delete"),
        },
        {
          value: "refund",
          label: this.$locale("trans.log.refund"),
          text: this.$locale("trans.log.refund"),
        }
      ],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
    }),
    tableHeader() {
      let _headerObj = [
        {
          label: this.$locale("global.id"), //ログID
          prop: "searchId",
          width: 140,
          align: "left",
          formatter: (row, column, cellValue, index) => {
            return formatStringFixed(cellValue);
          }
        },
        {
          label: this.$locale("trans.log.createTime"), //操作日時
          prop: "createTime",
          sortable: "custom",
          width: 100,
          align: "left",
          formatter: (row, column, cellValue) => {
            return this.timeFormatter(cellValue);
          },
        },
        {
          label: this.$locale("global.type"), //種類
          prop: "operationType",
          width: 80,
          align: "left",
          columnKey: "operationType",
          filters: this.operationTypeOption,
          formatter: (row, column, cellValue) => {
            const _obj = this.operationTypeOption.find(_option => _option.value === cellValue) || {};
            return _obj.label;
          },
        },
        {
          label: this.$locale("trans.log.transactionFinishTime"), //取引日時
          prop: "transactionFinishTime",
          sortable: "custom",
          width: 100,
          align: "left",
          formatter: (row, column, cellValue) => {
            return this.timeFormatter(cellValue);
          },
        },
      ];

      const _headerObj2 = [
        {
          label: this.$locale("trans.log.productName"), //商品名
          prop: "ticketTypeNameOrProductName",
          width: 140,
          align: "left",
        },
        {
          label: this.$locale("global.taxRate"), //税率
          prop: "taxRate",
          width: 80,
          formatter: (row, column, cellValue) => {
            return taxRatesMap[cellValue] || "";
          },
        },
        {
          label: this.$locale("global.unitPrice"), //単価
          prop: "unitPrice",
          align: "right",
          width: 100,
          formatter: (row, column, cellValue) => {
            return this.currencyFormatter(cellValue);
          },
        },
        {
          label: this.$locale("global.quantity"), //数量
          prop: "qty",
          width: 50,
        },
        {
          label: this.$locale("global.amount"), //金額
          prop: "totalAmount",
          width: 120,
          align: "right",
          formatter: (row, column, cellValue) => {
            return this.currencyFormatter(cellValue);
          },
        },
      ];

      switch(this.filter.transactionLogType) {
      case "ticket":
        _headerObj = [
          ..._headerObj,
          {
            label: this.$locale("global.titleOfWork"), //作品名
            prop: "filmName",
            align: "left",
          },
          {
            label: this.$locale("operation.NAT.screenDate"),
            prop: "scheduleDate",
            sortable: "custom",
            align: "left",
            formatter: row => {
              return this.$moment(row.scheduleStartTime).format("YYYY-MM-DD");
            },
          },
          {
            label: this.$locale("operation.NAT.showTime"),
            prop: "scheduleTime",
            sortable: "custom",
            align: "left",
            formatter: row => {
              return this.$moment(row.scheduleStartTime).format("HH:mm");
            },
          },
          {
            label: this.$locale("trans.log.ticketName"), //券種
            prop: "ticketTypeNameOrProductName",
          },
          {
            label: this.$locale("global.amount"), //金額
            prop: "totalAmount",
            width: 60,
            align: "right",
            formatter: (row, column, cellValue) => {
              return this.currencyFormatter(cellValue);
            },
          },
        ];
        break;
      case "goods":
        _headerObj = [
          ..._headerObj,
          ..._headerObj2,
        ];
        break;
      case "otherRevenue":
        _headerObj = [
          ..._headerObj,
          ..._headerObj2,
          {
            label: this.$locale("global.unit"), //単位
            prop: "unit",
            width: 60,
          },
        ];
        break;
      default:
        break;
      }

      _headerObj = [
        ..._headerObj,
        {
          label: this.$locale("trans.log.changePeople"), //デバイス/担当者
          prop: "userName",
          width: 140,
        },
        {
          label: this.$locale("trans.log.mark"), //コメント
          prop: "mark",
          width: 160,
          align: "left",
        },
      ];

      return _headerObj;
    },
  },
  watch: {
    "$route"() {
      this.pageInit();
    },
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    initFilter() {
      return {
        startDate: this.$moment().startOf("day").valueOf(),
        endDate: this.$moment().startOf("day").valueOf(),
        page: 0,
        pageSize: 10,
        search: "",
        sort: "",
        sortKey: "",
        transactionLogType: "",
        operationType: null,
      };
    },
    pageInit() {
      let _type = "";
      let _pageTitle = "";
      const _filter = this.initFilter();

      switch (this.$route.path) {
      case "/transaction-log-ticket":
        _type = "ticket";
        _pageTitle = this.$locale("sideMenu.reports.transactionLogTicket");
        break;
      case "/transaction-log-shop":
        _type = "goods";
        _pageTitle = this.$locale("sideMenu.reports.transactionLogShop");
        break;
      case "/transaction-log-other":
        _type = "otherRevenue";
        _pageTitle = this.$locale("sideMenu.reports.transactionLogOtherRevenue");
        break;
      default:
        break;
      }

      _filter.transactionLogType = _type;
      this.filter = _filter;
      this.pageTitle = _pageTitle;
      this.getData();

      const vm = this;
      this.$nextTick(() => {
        vm.$refs.table.clearSort();
        vm.$refs.table.clearFilter();
      });
    },
    getData() {
      if (this.cinemaId == "") {
        this.$emit("callCinema", "getData");
        return;
      }

      const { startDate, endDate } = this.filter;

      function isNumber(value) {
        return !isNaN(Number(value));
      }

      let obj = {
        ...this.filter,
        ...isNumber(this.filter.search.replace(' ', '')) ? { search: this.filter.search.replace(' ', '') } : {},
        cinemaId: this.cinemaId,
        startDate: this.$moment(startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(endDate).format("YYYY-MM-DD")
      };

      getTransactionLogList(obj).then(res => {
        if (res.success) {
          const { count, data } = res.data;
          this.pageCount = count || 0;
          this.tableData = data;

          // const week = [
          //   this.$locale("global.sun"),
          //   this.$locale("global.mon"),
          //   this.$locale("global.tue"),
          //   this.$locale("global.wed"),
          //   this.$locale("global.thu"),
          //   this.$locale("global.fri"),
          //   this.$locale("global.sat")
          // ];
          // const year = this.$locale("global.year");
          // const month = this.$locale("global.month");
          // const day = this.$locale("global.day");
          // let tableData = [];

          // res.data.data.map(item => {
          //   let tr = {};
          //   let createTime = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm");
          //   let operationType = "";
          //   let transactionFinishTime = this.$moment(item.transactionFinishTime).format("YYYY-MM-DD HH:mm");
          //   let scheduleStartTime = this.$moment(item.scheduleStartTime).format("YYYY-MM-DD HH:mm");

          //   for (let i = 0; i < this.operationTypeOption.length; i++) {
          //     if (this.operationTypeOption[i].value == item.operationType) {
          //       operationType = this.operationTypeOption[i].label;
          //       break;
          //     }
          //   }

          //   createTime = createTime.replace("-", year);
          //   createTime = createTime.replace("-", month);
          //   createTime = createTime.replace(" ", `${day}(${week[this.$moment(item.createTime).day()]})`);

          //   transactionFinishTime = transactionFinishTime.replace("-", year);
          //   transactionFinishTime = transactionFinishTime.replace("-", month);
          //   transactionFinishTime = transactionFinishTime.replace(" ", `${day}(${week[this.$moment(item.transactionFinishTime).day()]})`);

          //   scheduleStartTime = scheduleStartTime.replace("-", year);
          //   scheduleStartTime = scheduleStartTime.replace("-", month);
          //   scheduleStartTime = scheduleStartTime.replace(" ", `${day}(${week[this.$moment(item.scheduleStartTime).day()]})`);

          //   tr.searchId = item.searchId;
          //   tr.createTime = createTime;
          //   tr.operationType = operationType;
          //   tr.transactionFinishTime = transactionFinishTime;

          //   tr.ticketTypeNameOrProductName = item.ticketTypeNameOrProductName;
          //   tr.totalAmount = item.totalAmount > 0 ? ("¥" + item.totalAmount.toLocaleString()) : "/";

          //   tr.userName = item.userName;
          //   tr.mark = item.mark;

          //   if (this.type == "ticket") {
          //     tr.filmName = item.filmName;
          //     tr.scheduleStartTime = scheduleStartTime;
          //   } else if (this.type == "goods") {
          //     tr.unitPrice = item.unitPrice > 0 ? ("¥" + item.unitPrice.toLocaleString()) : "/";
          //     tr.qty = item.qty;
          //     // tr.taxRate = item.taxRate * 100 + "%";
          //     tr.taxRate = taxRatesMap[item.taxRate];
          //   } else {
          //     tr.unitPrice = item.unitPrice > 0 ? ("¥" + item.unitPrice.toLocaleString()) : "/";
          //     tr.qty = item.qty;
          //     tr.unit = item.unit == "" ? "/" : item.unit;
          //     // tr.taxRate = item.taxRate * 100 + "%";
          //     tr.taxRate = taxRatesMap[item.taxRate];
          //   }

          //   tableData.push(tr);
          // });

          // this.pageCount = Math.ceil(res.data.count / obj.pageSize);
          // this.pageCount = res.data.count || 0;
          // this.tableData = tableData;
        }
      });
    },
    getTime(obj) {
      this.filter = { ...this.filter, ...obj };
    },
    choosePage(page) {
      this.filter.page = page - 1;
      this.getData();
    },
    sortChange({ prop, order }) {
      let sort = "";
      let sortKey = "";

      if (order) {
        if (prop === "scheduleDate" || prop === "scheduleTime") {
          sortKey = "scheduleStartTime";
        } else {
          sortKey = prop;
        }

        if (order == "ascending") {
          sort = "ASC";
        } else {
          sort = "DESC";
        }
      }

      this.filter = { ...this.filter, sort, sortKey };
      this.getData();
    },
    filterChange(filters) {
      const { operationType } = filters;
      this.filter.operationType = operationType;
      this.filter.page = 0;

      this.getData();
    },
    exportCsv() {
      const {
        startDate,
        endDate,
        transactionLogType,
      } = this.filter;

      exportCSV_fn({
        startDate: this.$moment(startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(endDate).format("YYYY-MM-DD"),
        transactionLogType,
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }, this.operationTypeOption, transactionLogType, this.filter.startDate, this.filter.endDate, weekLocaleArray);
    },
    exportCSV_fn() {
      let fileName = this.pageTitle + ".csv";
      let column = [];
      let thead = [];
      let str = "";

      switch (this.filter.transactionLogType) {
      case "ticket":
        thead = [
          this.$locale("global.id"),
          this.$locale("trans.log.createTime"),
          this.$locale("global.type"),
          this.$locale("trans.log.transactionFinishTime"),
          this.$locale("global.titleOfWork"),
          this.$locale("trans.report.scheduleStartTime"),
          this.$locale("trans.log.ticketName"),
          this.$locale("global.amount"),
          this.$locale("trans.log.changePeople"),
          this.$locale("trans.log.mark")
        ];
        column = [
          "searchId",
          "createTime",
          "operationType",
          "transactionFinishTime",
          "filmName",
          "scheduleStartTime",
          "ticketTypeNameOrProductName",
          "totalAmount",
          "userName",
          "mark"
        ];
        break;
      case "goods":
        thead = [
          this.$locale("global.id"),
          this.$locale("trans.log.createTime"),
          this.$locale("global.type"),
          this.$locale("trans.log.transactionFinishTime"),
          this.$locale("trans.log.productName"),
          this.$locale("global.unitPrice"),
          this.$locale("global.quantity"),
          this.$locale("global.amount"),
          this.$locale("global.taxRate"),
          this.$locale("trans.log.changePeople"),
          this.$locale("trans.log.mark")
        ];
        column = [
          "searchId",
          "createTime",
          "operationType",
          "transactionFinishTime",
          "ticketTypeNameOrProductName",
          "unitPrice",
          "qty",
          "totalAmount",
          "taxRate",
          "userName",
          "mark"
        ];
        break;
      case "otherRevenue":
        thead = [
          this.$locale("global.id"),
          this.$locale("trans.log.createTime"),
          this.$locale("global.type"),
          this.$locale("trans.log.transactionFinishTime"),
          this.$locale("trans.log.product"),
          this.$locale("global.unitPrice"),
          this.$locale("global.quantity"),
          this.$locale("global.amount"),
          this.$locale("global.unit"),
          this.$locale("global.taxRate"),
          this.$locale("trans.log.changePeople"),
          this.$locale("trans.log.mark")
        ];
        column = [
          "searchId",
          "createTime",
          "operationType",
          "transactionFinishTime",
          "ticketTypeNameOrProductName",
          "unitPrice",
          "qty",
          "totalAmount",
          "unit",
          "taxRate",
          "userName",
          "mark"
        ];
        break;
      default:
        break;
      }

      this.$refs.table.$options.propsData.data.map(item => {
        let arr = [];

        column.map(keyName => {
          arr.push(item[keyName]);
        });

        str = str + arr.toString() + "\n";
      });

      str = thead.toString() + "\n" + str;

      if (navigator.msSaveOrOpenBlob) {
        let BOM = "\uFEFF";
        let blob = new Blob([ BOM + str ], { type: "text/csv;charset=utf-8;" });
        navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + str;
        let link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    currencyFormatter(value) {
      return "¥" + toThousands(value);
    },
    timeFormatter(value) {
      return this.$moment(value).format("LL (ddd) HH:mm");
    },
    dateDisableDate(time) {
      return time.getTime() > this.$moment().valueOf();
    },
  },
};
</script>

<style lang="less">
.transaction-log {
  .search-area {
    border-bottom: 1px dashed #d2d2d2;
    padding-bottom: 20px;

    .name-input {
      padding-top: 30px;
    }
  }
}
</style>
